import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from './AuthContext';
import { getMyPerformanceTasks } from '../api/retailPerformanceTasks';

const PerformanceTaskContext = createContext();

export const usePerformanceTask = () => {
  return useContext(PerformanceTaskContext);
};

export const PerformanceTaskProvider = ({ children }) => {
  const { user } = useAuth();
  const [activeTasks, setActiveTasks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isWidgetOpen, setIsWidgetOpen] = useState(true); // Default open

  // Polling interval (e.g., every 30 seconds)
  const POLLING_INTERVAL = 30000;

  const fetchActiveTasks = useCallback(async () => {
    if (!user) return;

    try {
      // Fetch only active and scheduled tasks for the widget
      const response = await getMyPerformanceTasks({
        status: ['active', 'scheduled', 'paused'].join(','),
        limit: 5
      });

      if (response.success) {
        setActiveTasks(response.data);
      }
    } catch (error) {
      console.error('Error fetching active performance tasks:', error);
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      fetchActiveTasks();
      const intervalId = setInterval(fetchActiveTasks, POLLING_INTERVAL);
      return () => clearInterval(intervalId);
    } else {
      setActiveTasks([]);
    }
  }, [user, fetchActiveTasks]);

  const toggleWidget = () => {
    setIsWidgetOpen((prev) => !prev);
  };

  const refreshTasks = () => {
    fetchActiveTasks();
  };

  const value = {
    activeTasks,
    loading,
    isWidgetOpen,
    toggleWidget,
    refreshTasks
  };

  return (
    <PerformanceTaskContext.Provider value={value}>{children}</PerformanceTaskContext.Provider>
  );
};
